var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filters-multiselect',{attrs:{"placeholder":_vm.$t('geo'),"multiple":true,"model":_vm.searchGeoValue,"options":_vm.geoList},on:{"searchItem":_vm.geoPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }